<template>
  <div>
    <PayableReceivableListMain />
  </div>
</template>

<script>
import PayableReceivableListMain from "../components/payableReceivable/PayableReceivableListMain.vue";

export default {
  name: "PayableReceivableListView",
  components: { PayableReceivableListMain },
};
</script>
